import facebookIcon from '../../assets/icons/facebook.svg'
import twitterIcon from '../../assets/icons/twitter.svg'

const supportedSocialChannels = [
	{
		type: 'facebook',
		content: null,
		icon: facebookIcon,
		apiLink: 'http://www.facebook.com/sharer.php?u=https://mamashelter.com/'
	},
	{
		type: 'twitter',
		content: null,
		icon: twitterIcon,
		apiLink: 'http://twitter.com/share?text=Mama Loves You.&url=https://mamashelter.com/'
	}
]
export default supportedSocialChannels



// WEBPACK FOOTER //
// ./src/utilities/social/supportedSocialChannels.js